import React, { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FirebaseContext } from "../context/FirebaseContext";
import { signOut } from "firebase/auth";

import "../styles/sidebar.style.scss";

function SideBar({ openSideBar, setOpenSideBar }) {
  const { auth } = useContext(FirebaseContext);
  const navigate = useNavigate();
  function handleLogout(e) {
    e.preventDefault();
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        setTimeout(() => {
          navigate("/", {
            replace: true,
          });
        }, 250);

        console.log("Signed out successfully");
      })
      .catch((error) => {
        // An error happened.
      });
  }
  return (
    <div className={`aside-content ${openSideBar ? "open" : "close"}`}>
      <aside className="side-bar">
        <nav>
          <ul>
            <li>
              <NavLink
                to="/admin"
                end
                onClick={(e) => {
                  setTimeout(() => {
                    setOpenSideBar(false);
                  }, 250);
                }}
              >
                Tableau de bord
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admin/gestionVente"
                onClick={(e) => {
                  setTimeout(() => {
                    setOpenSideBar(false);
                  }, 250);
                }}
              >
                Gestion vente
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admin/ajoutProduit"
                onClick={(e) => {
                  setTimeout(() => {
                    setOpenSideBar(false);
                  }, 250);
                }}
              >
                Ajout produit
              </NavLink>
            </li>
            <li className="hidden max-lg:block">
              <NavLink
                to="/admin/parametre"
                onClick={(e) => {
                  e.preventDefault();
                  setTimeout(() => {
                    setOpenSideBar(false);
                  }, 250);
                }}
              >
                Parametre
              </NavLink>
            </li>
            <li className="hidden max-lg:block">
              <NavLink
                to="/admin/compte"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenSideBar(false);
                }}
              >
                Mon compte
              </NavLink>
            </li>
            <li className="hidden max-lg:block">
              <NavLink to="/admin/disconnect" onClick={handleLogout}>
                Se deconnecter
              </NavLink>
            </li>
          </ul>
        </nav>
      </aside>
    </div>
  );
}

export default SideBar;
